import { call, put, takeLatest } from "redux-saga/effects";
import { GET_DocumentList, POST_Document, DELETE_Document, GET_TaskAttachments, POST_TaskAttachment, DELETE_TaskAttachment } from "../services/Document";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_DocumentListEffect({ projectId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DocumentList, token, projectId);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DocumentList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_DocumentEffect({ projectId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(POST_Document, token, projectId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_DocumentEffect({ documentId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(DELETE_Document, token, documentId);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_TaskAttachmentsEffect({ taskId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_TaskAttachments, token, taskId);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_TaskAttachments", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_TaskAttachmentEffect({ taskId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(POST_TaskAttachment, token, taskId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_TaskAttachmentEffect({ attachmentId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(DELETE_TaskAttachment, token, attachmentId);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_DocumentList", GET_DocumentListEffect);
  yield takeLatest("POST_Document", POST_DocumentEffect);
  yield takeLatest("DELETE_Document", DELETE_DocumentEffect);
  yield takeLatest("GET_TaskAttachments", GET_TaskAttachmentsEffect);
  yield takeLatest("POST_TaskAttachment", POST_TaskAttachmentEffect);
  yield takeLatest("DELETE_TaskAttachment", DELETE_TaskAttachmentEffect);
}
